import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CustomKeyboardComponent } from '@stockcare-components/custom-keyboard/custom-keyboard.component';
import { KeyboardTemplate } from '@stockcare-components/custom-keyboard/keyboard-templates';
import { SettingsService } from '@stockcare-services/settings-service/settings.service';

@Component({
  standalone: false,
  selector: 'app-create-patient-note-dialog',
  templateUrl: './create-patient-note-dialog.component.html',
  styleUrls: ['./create-patient-note-dialog.component.scss'],
})
export class CreatePatientNoteDialog implements OnInit {
  @ViewChild('customKeyboard') public customKeyboard: CustomKeyboardComponent;
  public standardTemplate = KeyboardTemplate.StandardWithSpaceAndEnter;
  enableCustomKeyboard: boolean = false;
  isTextareaFocused: boolean = false;
  searchValue: string;
  
  form: UntypedFormGroup;
  patientName: string;
  casenumber: string;
  
  constructor(
    private settingsService: SettingsService,
    public dialogRef: MatDialogRef<CreatePatientNoteDialog>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.patientName = this.data.patientName;
    this.casenumber = this.data.casenumber;
  }

  ngOnInit() {
    this.buildForm();

    this.enableCustomKeyboard = this.settingsService.enableCustomKeyboard();
  }

  cancelDialog() {
    this.dialogRef.close(false);
  }

  private buildForm() {
    this.form = new UntypedFormGroup({
      note: new UntypedFormControl(null,  Validators.required),
    });
  }

  private validate(): boolean {
    this.touchAllControls();
    if (!this.form.valid) {
      return false;
    }
    return true;
  }

  private touchAllControls() {
    // tslint:disable-next-line:forin
    for (const i in this.form.controls) {
      this.form.controls[i].markAsTouched();
    }
  }

  get controls() {
    return this.form.controls;
  }

  confirm() {
    if (!this.validate()) {
      return;
    }
    
    this.dialogRef.close(this.form.controls.note.value);
  }

  get getInputMode() {
    if (this.enableCustomKeyboard) {
      return 'none';
    }
    return 'text';
  }

  onTextareaFocused(value: boolean) {
    this.isTextareaFocused = value;
  }

  isCustomKeyboardVisible(): boolean {
    return this.enableCustomKeyboard && this.isTextareaFocused;
  }

  public customKeyboardInput(inputText: string) {
    this.searchValue = inputText;
  }
}
